<template>
  <div class="d-flex flex-column mobile-menu__links">
    <template v-for="link of headLinks">
      <a
        v-if="!link.separator"
        :key="link.name"
        v-bind="link"
      >
        <div class="d-flex cursor-pointer">
          <span v-html="link.name" />
        </div>

        <div class="link-group__inner--mobile">
          <MobileHeadLink
            :data-head-link="link.name"
            :links="link.links"
            :headerLinkTarget="headerLinkTarget"
          />
        </div>
      </a>
    </template>
  </div>
</template>

<script>
export default {
  name: 'MobileHeadLink',
  props: {
    links: Array,
    headerLinkTarget: String
  },
  computed: {
    headLinks () {
      return this.links.map(link => {
        const _link = {
          target: this.headerLinkTarget,
          'data-head-link': link.name,
          'data-head-link-list': !!(this.isAdditionalLinks(link)),
          ...link,
          class: 'link-group--mobile' + (link.class ? ` ${link.class}` : ''),
        }
        if (link.url) {
          _link.href = link.url
        }
        return _link
      })
    }
  },
  methods: {
    isAdditionalLinks (link) {
      return link.links && link.links.length
    }
  }
}
</script>

<style lang="scss" scoped>
.green-link span {
  color: #00AFA1;
  position: relative;

  &:before {
    content: '';
    position: absolute;
    right: -15px;
    top: 50%;
    width: 6px;
    height: 6px;
    margin-top: -4.5px;
    border-top: 2px solid #00AFA1;
    border-left: 2px solid #00AFA1;
    transform: rotate(135deg);
  }
}

.cursor-pointer {
  cursor: pointer;
}

.link-group--mobile {
  line-height: 1.44;
  font-size: 18px;
  font-weight: bold;
  color: inherit;
  text-decoration: none;

  &:first-child {
    margin-top: 14px;
  }
}
.icon-droplist--mobile {
  position: relative;
  top: 2px;
  left: 15px;

  ::v-deep svg {
    transition: all .2s ease;
    width: 18px !important;
    height: 18px !important;
  }
}
.link-group__inner {
  width: 100%;
  display: flex;

  &--mobile {
    padding-left: 15px;
  }
}

.mobile-menu__links {
  display: flex;
  flex-direction: column;
  gap: 15px;
}
</style>
